export const menuBookFeatureTranslationJP = {
  MenuBookListPage: {
    head_title: 'メニューブック一覧',
    search: '絞り込み',
    search_detail: '詳細絞り込み',
    menu_book: 'メニューブック',
    menu_book_name: 'メニューブック名',
    course: 'コース',
    course_name: 'コース名',
    sale_type: '販売タイプ',
    store: '店舗',
    target_date: '対象日',
    store_name: '店舗名',
    add_menu_book: 'メニューブック追加',
    select_all: '全選択',
    unselect_all: '解除',
    detail: '詳細',
    add_course: 'コース追加',
    copy: '複製',
    delete: '削除',
    restore: '復元',
    selection: '選択',
    edit_menu_book: 'メニューブック編集',
    edit: '編集',
    show_all: '削除データ含めて表示',
    show_valid: '削除データ非表示',
    show_deleted: '削除データのみ表示',
    tab_search_sale_type: '販売タイプ',
    tab_search_store: '店舗名',
    all_restaurant: '全レストラン',
    all_saletype: '全販売タイプ',
    warn_confirm_delete: '選択されたメニューブックを削除します。<br/>よろしいですか？',
    warn_copy_success: 'コピーに成功しました',
    warn_copy_failed: 'コピーに失敗しました',
    warn_confirm_restore: '選択されたメニューブックを復元します。<br/>よろしいですか？',
    warning_save_data: 'データが変更されました。<br/>データを保存しますか。',
    priority_order: '優先順位',
  },
  EditMenuBookModal: {
    head_title: 'メニューブック編集',
    guide_title: '※並び順の変更について',
    guide_description:
      '変更したい箇所をフォーカスし、キーボード操作で並び順を変更することができます。並び順は、モバイルオーダーの表示順に反映されます。',
    expand_all: '開く',
    collapse_all: '全てを閉じる',
    add_genre: 'ジャンル追加',
    add_subgenre_or_add_menu: 'サブジャンル／メニュー追加',
    copy: '複製',
    delete: '削除',
    save: '保存',
    genre: 'ジャンル',
    subgenre: 'サブジャンル',
    menu: 'メニュー',
    sub_menu_group: 'サブメニューグループ',
    sub_menu: 'サブメニュー',
    default_priority: 'デフォルト順',
    deadline: '有効期限',
    show_only_active: '現在有効なものを表示',
    show_only_disabled: '現在無効なものを表示',
    show_follow_date: '以下の日付に有効なものを表示',
    related_pos: '関連するレジ情報',
    valid_date_title: '以下の日付に有効なものを表示',
    valid_date_note: '※関連するレジ情報からメニューを抽出します。',
  },
  MenuBookDetailModal: {
    head_title: 'メニューブック詳細',
    guide_title: '※モバイルオーダーの表示名は、',
    guide_description: '日本語以外の言語を選択し、その言語が未設定の場合、英語が表示されます。',
    close: '閉じる',
    save: '保存',
    menu_book_name: 'メニューブック名',
    property: 'プロパティ',
    display_name: '表示名',
    japanese: '日本語',
    english: '英語',
    simplified_chinese: '中国語（簡体字）',
    transitional_chinese: '中国語（繁体字）',
    korean: '韓国語',
    vietnamese: 'ベトナム語',
    introduce_image: '紹介画像',
    introduce_image_note: '※注文前にメニューブックを選択すると表示される画像',
    for_mobile_order: 'モバイルオーダー用',
    for_tablet_order: 'タブレットオーダー用',
    change: '変更',
    remark: '備考',
    warn_field_required: 'この項目は必須です',
    warn_value_number_greater_equal_0: '値は 0 以上である必要があります。',
    warn_value_number_integer: '整数を入力してください',
    property_no_value: '選択なし',
    property_type1: '食べ放題／飲み放題',
    property_type2: 'ピタ放題',
    button_heading_settings: 'ボタン／見出し設定',
    color_setting: '色指定',
    background_setting: '背景画像',
    color_setting_guide: '未選択時のボタン背景色と文字色を指定できます。',
    background_setting_guide:
      '※ボタン画像の設定をONにすると、タブレットオーダーのボタンは背景色ではなくここで設定した画像が表示されます。',
    background: '背景色',
    color: '文字色',
    priority_order: '優先順位',
    priority_guide:
      'メニューブックをまたがって、コースが同時に複数オーダーされた際の優先的に表示する順位を設定できます。',
  },
  GenreAddModal: {
    title: 'ジャンル追加',
    search: '絞り込み',
    name: '名称：',
    link_to: '※リストない場合は、こちらから追加',
    select_all: '全選択',
    cancle_all: '解除',
    reload: 'リロード',
    add: '追加',
    table: {
      selection: '選択',
      genre_name: 'ジャンル名',
    },
  },
  SubGenreAddModal: {
    title: '特盛ランチ｜サブジャンル追加',
    search: '絞り込み',
    name: '名称：',
    fair: 'フェア：',
    all: '全て',
    fair_only: 'フェアのみ',
    other_than_fair: 'フェア以外',
    link_to: '※リストない場合は、こちらから追加',
    select_all: '全選択',
    cancle_all: '解除',
    reload: 'リロード',
    add: '追加',
    table: {
      selection: '選択',
      subgenre_name: 'サブジャンル名',
    },
  },
  MenuAddModal: {
    title: '特盛ランチ｜黒毛和牛ランチ｜メニュー追加',
    search: '絞り込み',
    menu_classification: 'メニュー分類：',
    name: '名称：',
    menu_code: 'メニューコード：',
    select_all: '全選択',
    cancle_all: '解除',
    reload: 'リロード',
    add: '追加',
    table: {
      selection: '選択',
      menu_code: 'メニューコード',
      menu_name: 'メニュー名',
    },
    confirm:
      '通常メニューとして表示できるPOSコードが存在しないメニューがあります。存在しないメニューを除くメニューを追加します。',
  },
  DuplicationDisplayModal: {
    title: '複製',
    from: 'コピー元',
    to: 'コピー先',
    menu_book: 'メニューブック',
    menu_book_course: 'メニューブック・コース',
    genre: 'ジャンル',
    subGenre: 'サブジャンル',
    copy: '複製',
  },
  CourseDetailModal: {
    head_title: 'コース詳細',
    guide_title: '※モバイルオーダーの表示名は、',
    guide_description: '日本語以外の言語を選択し、その言語が未設定の場合、英語が表示されます。',
    save: '保存',
    course_name: 'コース名',
    classification: 'コース分類',
    target_menu: '対象メニュー',
    target_menu_description: 'メニューコード指定',
    condition: 'セット条件',
    condition_description: 'メニューコード指定',
    condition_note: '※例：コース＋お寿司セットで１つとして扱うようなもの',
    limited_time: '制限時間（分）',
    display_name: 'コース表示名',
    japanese: '日本語',
    english: '英語',
    simplified_chinese: '中国語（簡体字）',
    transitional_chinese: '中国語（繁体字）',
    korean: '韓国語',
    vietnamese: 'ベトナム語',
    remark: '備考',
    all_you_can_eat: '食べ放題',
    all_you_can_drink: '飲み放題',
    warn_field_required: 'この項目は必須です',
    warn_value_number_greater_equal_0: '値は 0 以上である必要があります。',
    warn_value_number_integer: '整数を入力してください',
    for_mobile_order: 'モバイルオーダー用',
    for_tablet_order: 'タブレットオーダー用',
    button_heading_settings: 'ボタン／見出し設定',
    color_setting: '色指定',
    background_setting: '背景画像',
    color_setting_guide: '未選択時のボタン背景色と文字色を指定できます。',
    background_setting_guide:
      '※ボタン画像の設定をONにすると、タブレットオーダーのボタンは背景色ではなくここで設定した画像が表示されます。',
    background: '背景色',
    color: '文字色',
    priority_guide:
      'メニューブックをまたがって、コースが同時に複数オーダーされた際の優先的に表示する順位を設定できます。',
    priority_order: '優先順位',
    limit_type: 'デザート一人一品',
    limit_type_guide: 'こちらを設定すると、選択した注文数制限を設定したメニューに対して制限が適用されます。',
    no_limit_type: '設定無し',
    allow: '有効化',
  },
  SelectCourseMenuModal: {
    head_title: 'コース メニュー選択',
    menu_code: 'メニューコード',
    menu_name: 'メニュー名称',
    search: '絞り込み',
    selection: '選択',
    menu: 'メニュー',
  },
};
